export const PRICING_INSIGHTS_URL =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://pricing-insights.superdispatch.com'
    : 'https://staging.pricing-insights.superdispatch.org';

export const WEBSITE_SIGNUP_URL =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://signup.superdispatch.com'
    : 'https://website-signup-staging.web.app';
